import Vue from 'vue';
import { createHobbitApp } from 'hobbit-base';
import { loadJS } from 'hobbit-base/modules/utils';
import mainHelper from 'hobbit-base/components/bizs/main/main-helper';
// 常用全局通用组件
import AlloyFinger from 'alloyfinger';
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue';
import appView from 'hobbit-engine-base/app/app.vue'; // App.vue 页面母版
import User from 'hobbit-engine-base/modules/user'; // 鉴权和用户基本属性相关模块
import { extendStatisticsInit } from 'hobbit-engine-base/modules/thirdparty/extendStatistics';
import useWebLog from 'hobbit-engine-base/modules/webLog';

// eslint-disable-next-line import/no-dynamic-require
const config = require(`../config/${process.env.VUE_APP_RUNTIME}`);

createHobbitApp(
  appView,
  config,
  ({ $hobbit, router }) => {
    const $config = $hobbit.$config;
    const $ctx = $hobbit.$ctx;
    const $fetch = $hobbit.$fetch;
    // #region =#=#=#=#=#=#=#=#=#= 扩展项目级别基础模块 =#=#=#=#=#=#=#=#=#=
    const $user = new User($config, $fetch, $ctx);
    Vue.prototype.$user = $user;
    Vue.use(AlloyFingerPlugin, { AlloyFinger });
    // #endregion

    // #region =#=#=#=#=#=#=#=#=#= 初始化业务和语言、时区、主题 =#=#=#=#=#=#=#=#=#=
    // 计算实时时差
    $ctx.vkTimezone = mainHelper.getVKTimezone();

    // 初始化业务码
    mainHelper.bizInit($hobbit);
    const bizConfig = $config.site.bizs[$ctx.biz];
    if (bizConfig?.busEnable) {
      $ctx.vkBusDomain = window.location.host.replace(/^pre-|^test-/i, '');
    }

    // 引擎配置初始化
    const themeInstalled = mainHelper.themeInstall($hobbit, $ctx.biz);

    // 语言初始化
    mainHelper.langInit($hobbit);

    // 404错误页初始化
    mainHelper.error404Init($hobbit, router);

    // 路由前置校验逻辑初始化
    mainHelper.routerPreCheckInit($hobbit, router, themeInstalled);

    // 初始化代理员信息
    mainHelper.vipAgentInit($hobbit, router);

    // #region =#=#=#=#=#=#=#=#=#= LOG模块初始化 =#=#=#=#=#=#=#=#=#=
    mainHelper.logInit($hobbit, themeInstalled);
    extendStatisticsInit($hobbit, router, themeInstalled);
    useWebLog($hobbit).then(tracker => { $ctx.webTracker = tracker; });
    // #endregion
    // #region =#=#=#=#=#=#=#=#=#= 监控 =#=#=#=#=#=#=#=#=#=
    // arms($hobbit); // 由于该监控影响其他统计，暂时关闭
    // #endregion

    // #region =#=#=#=#=#=#=#=#=#= Fetch模块初始化 =#=#=#=#=#=#=#=#=#=
    (function initFetch() {
      // 接口请求AOP
      $fetch.hooks.beforeRequest = mainHelper.getDefaultFetchBeforeRequest($hobbit);

      // 接口响应AOP
      $fetch.hooks.afterResponse = response => {
        mainHelper.apiStat(response, $hobbit);

        // 未登录, 如果没指定忽略401，则自动引导登录
        if (response.errorCode === 401 || response.errorCode === 4109) {
          // 删除本地登录态信息
          window.$hobbit.$user.logout(null);
          if (!response.options.preventDefaultAuthCheck) {
            $user.gotoLogin();
          }
        } else if (bizConfig?.busEnable && response.errorCode === 400002) {
          window.$hobbit.$app.pageReplace(`/${$ctx.lang}/website/service/error404/`);
        } else if (response.errorCode === 400003) {
          if (window.$hobbit.$ctx.isApp()) {
            window.$hobbit.$user.logout(null);
          } else {
            // 拦截临时token，仅可访问重置密码页面
            window.$hobbit.$app.pageTo(`/website/account/resetpassword/?backurl=${encodeURIComponent(window.location.href)}`);
          }
        }
      };
    }());
    // #endregion

    // if (window.$hobbit.$ctx.isApp) {
    //   document.addEventListener('visibilitychange', (e) => {
    //     if (document.visibilityState === 'visible') {
    //       // 页面变为可见状态时执行的操作
    //       window.$hobbit.$app.pageReload();
    //     }
    //   });
    // }

    const waitList = [];
    // #region =#=#=#=#=#=#=#=#=#= 其它杂项初始化 =#=#=#=#=#=#=#=#=#=
    // MOCK配置
    if ($config.fetch.mock) {
      waitList.push(import(/* webpackChunkName: "mocks" */'@/mocks').then(mocks => {
        $fetch.mockConfig = mocks.default;
      }));
    }

    // 加载调试控制台
    if ($config.site.vconsole && window.top === window && !$ctx.isPC()) {
      waitList.push(loadJS('//s.vipkidstatic.com/fe-static/hobbit/asset/lib/eruda.min.js?v2').then(() => window.eruda.init()));
    }
    // #endregion
    return Promise.all(waitList).catch(() => null);
  },
);
